<template>
<div id="homepage">
<div class="top-baner" style="background-color: rgb(207, 207, 207);">
        <div class="arrows">
            <!--- data-autoplay="0" data-loop="1" data-speed="900" -->
            <div class="swiper-container main-slider-6" data-loop="1" data-speed="900" data-center="0" data-slides-per-view="1">
                <div class="swiper-wrapper">
                    <div class="swiper-slide active" data-val="0">
                        <div class="clip">

                            <div class="bg bg-bg-chrome act" data-echo-background="https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_1400/v1513751346/DSC02131_kzeohx.jpg"
                                style="background-url (data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7);"></div>
                        </div>
                        <div class="vertical-align">
                            <div class="container">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-7 col-sm-offset-1">
                                        <div class="main-title style-3 left">
                                           
                                            <p class="color-white-light1">
                                                <!--
                                                <blockquote class="blockquote style-2">
                                                    <img src="/static/img/quot.png" alt="" style="filter: invert(100%);">
                                                    <p>Nuestro acogedor hostal será el lugar ideal para pasar sus fines de semana
                                                        o sus vacaciones bajo el sol del caribe y frente al hermoso mar en
                                                        Taganga. Los cuales haran de sus vacaciones un recuerdo inolvidable.</p>
                                                    <footer style="color: white;">
                                                        <cite title="Source Title">- Hostal Pelikan Taganga</cite>
                                                    </footer>
                                                </blockquote>
                                                -->
                                            </p>
                                            <!--
                                            <div class="clearfix"></div>
                                            <a href="#" class="c-button b-60 bg-sea hv-sea-o delay-2">
                                                <span>Descanco en paraiso natural. Hostal Pelikan</span>
                                            </a>
                                        -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="swiper-slide" data-val="1">
                        <div class="clip">
                            <div class="bg bg-bg-chrome act" data-echo-background="https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_1400/v1513750952/DSC02079_y92kyl.jpg" ></div>
                        </div>
                        <div class="vertical-align">
                            <div class="container">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-10 col-sm-offset-1">
                                        <div id="slider2text" class="main-title style-3 left" style="visibility: hidden;">

                                            <h1>
                                                <span class="color-sea">Descanso</span>
                                                y tranqilidad
                                            </h1>
                                            <p class="color-white-light">Curabitur nunc erat, consequat in erat ut, congue bibendum nulla. Suspendisse
                                                id pharetra lacus, et hendrerit mi quis leo elementum. Lorem ipsum dolor
                                                sit.
                                            </p>
                                            <div class="clearfix"></div>
                                            <a href="#" class="c-button b-60 bg-sea hv-sea-o delay-2">
                                                <span>ver mas</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                </div>

                <div class="pagination pagination-hidden poin-style-1"></div>
                <div class="arrow-wrapp arr-s-4">
                    <div class="cont-1170">
                        <div class="swiper-arrow-left sw-arrow">
                            <span class="fa fa-angle-left"></span>
                        </div>
                        <div class="swiper-arrow-right sw-arrow">
                            <span class="fa fa-angle-right"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="top-preview row no-margin">
        <div class="col-xs-12 col-sm-6 col-md-3 no-padding">
            <div class="tp_entry">
                <div class="tp_image">
                    <img class="center-image" src="https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_337/v1513656022/stock-photo-121747485_u2omz9.jpg"
                        alt="">
                    <div class="price price-s-2">45 minutos</div>
                </div>
                <div class="tp_content">

                    <div class="rate-wrap">
                        <div class="rate">
                            <span class="fa fa-star color-yellow"></span>
                            <span class="fa fa-star color-yellow"></span>
                            <span class="fa fa-star color-yellow"></span>
                            <span class="fa fa-star color-yellow"></span>
                            <span class="fa fa-star color-yellow"></span>
                        </div>
                        <i>recomendamos visitar</i>
                    </div>

                    <h4>
                        <b>
                            <a href="#">Cabo San Juan</a>
                        </b>
                    </h4>
                    <div class="date">disponible todo el año
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-3 no-padding">
            <div class="tp_entry">
                <div class="tp_image">
                    <img class="center-image" src="https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_337/v1513656022/stock-photo-121747485_u2omz9.jpg"
                        alt="">
                    <div class="price price-s-2">45 minutos</div>
                </div>
                <div class="tp_content">

                    <div class="rate-wrap">
                        <div class="rate">
                            <span class="fa fa-star color-yellow"></span>
                            <span class="fa fa-star color-yellow"></span>
                            <span class="fa fa-star color-yellow"></span>
                            <span class="fa fa-star color-yellow"></span>
                            <span class="fa fa-star color-yellow"></span>
                        </div>
                        <i>recomendamos visitar</i>
                    </div>

                    <h4>
                        <b>
                            <a href="#">Cabo San Juan</a>
                        </b>
                    </h4>
                    <div class="date">disponible todo el año
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-3 no-padding">
            <div class="tp_entry">
                <div class="tp_image">
                    <img class="center-image" src="https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_337/v1513656022/stock-photo-121747485_u2omz9.jpg"
                        alt="">
                    <div class="price price-s-2">45 minutos</div>
                </div>
                <div class="tp_content">

                    <div class="rate-wrap">
                        <div class="rate">
                            <span class="fa fa-star color-yellow"></span>
                            <span class="fa fa-star color-yellow"></span>
                            <span class="fa fa-star color-yellow"></span>
                            <span class="fa fa-star color-yellow"></span>
                            <span class="fa fa-star color-yellow"></span>
                        </div>
                        <i>recomendamos visitar</i>
                    </div>

                    <h4>
                        <b>
                            <a href="#">Cabo San Juan</a>
                        </b>
                    </h4>
                    <div class="date">disponible todo el año
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-3 no-padding">
            <div class="tp_entry">
                <div class="tp_image">
                    <img class="center-image" src="https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_337/v1513656022/stock-photo-121747485_u2omz9.jpg"
                        alt="">
                    <div class="price price-s-2">45 minutos</div>
                </div>
                <div class="tp_content">

                    <div class="rate-wrap">
                        <div class="rate">
                            <span class="fa fa-star color-yellow"></span>
                            <span class="fa fa-star color-yellow"></span>
                            <span class="fa fa-star color-yellow"></span>
                            <span class="fa fa-star color-yellow"></span>
                            <span class="fa fa-star color-yellow"></span>
                        </div>
                        <i>recomendamos visitar</i>
                    </div>

                    <h4>
                        <b>
                            <a href="#">Cabo San Juan</a>
                        </b>
                    </h4>
                    <div class="date">disponible todo el año
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="main-wraper padd-0 ">
        <div class="container">

            <div class="row">
                <div class="col-xs-12 col-sm-8 col-sm-offset-2">
                    <div class="second-title">
                        <h4 class="subtitle color-red-3 underline">Hostal Pelikan Taganga</h4>
                        <h2>Habitaciones</h2>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="top-baner arrows">
                    <div class="swiper-container fly-slider swiper-swiper-unique-id-0 initialized pagination-hidden" data-autoplay="0" data-loop="0"
                        data-speed="1000" data-slides-per-view="responsive" data-mob-slides="1" data-xs-slides="2" data-sm-slides="2"
                        data-md-slides="3" data-lg-slides="4" data-add-slides="4" id="swiper-unique-id-0">
                        <div class="swiper-wrapper" style="width: 1172px; transform: translate3d(0px, 0px, 0px); transition-duration: 0s; height: 459px;">
                            <div class="swiper-slide swiper-slide-visible swiper-slide-active" style="width: 293px; height: 459px;">
                                <div class="hotel-item style-7">
                                    <div class="radius-top">
                                        <!-- https:///static.wix/static.com/media/7a1375_aea4a6529d444d88a7f5f98a2f1d1cd1.png/v1/fill/w_649,h_408,q_85,usm_0.66_1.00_0.01/7a1375_aea4a6529d444d88a7f5f98a2f1d1cd1.png -->
                                        <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-echo="https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_265/v1513378777/DSC01473_dgsrbd.jpg"
                                            alt="">
                                    </div>
                                    <div class="title">
                                        <h5>desde
                                            <strong class="color-red-3">20.000 COP</strong>
                                        </h5>
                                        <!--  <h6 class="color-grey-3">Dormitorio</h6>-->
                                        <h4>
                                            <b>Dormitorio</b>
                                        </h4>
                                        <p>Dormitorio con baño privado, ideal cuando viajas con tu grupo de amigos
                                        </p>
                                        <div class="clearfix">
                                            <a href="#" class="c-button b-40 bg-red-3 hv-red-3-o fl">book now</a>
                                            <a href="#" class="c-button b-40 color-grey-3 hv-o fr">
                                                <img src="/static/img/flag_icon_grey.png" alt="">ver mas</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide swiper-slide-visible" style="width: 293px; height: 459px;">
                                <div class="hotel-item style-7">
                                    <div class="radius-top">

                                        <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-echo="https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_265/v1513378640/DSC01385_ky8tm8.jpg"
                                            alt="">
                                    </div>
                                    <div class="title">
                                        <h5>desde
                                            <strong class="color-red-3">20.000 COP</strong>
                                        </h5>
                                        <!--  <h6 class="color-grey-3">Dormitorio</h6>-->
                                        <h4>
                                            <b>Dormitorio</b>
                                        </h4>
                                        <p>Dormitorio con baño privado, ideal cuando viajas con tu grupo de amigos
                                        </p>
                                        <div class="clearfix">
                                            <a href="#" class="c-button b-40 bg-red-3 hv-red-3-o fl">book now</a>
                                            <a href="#" class="c-button b-40 color-grey-3 hv-o fr">
                                                <img src="/static/img/flag_icon_grey.png" alt="">ver mas</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide swiper-slide-visible" style="width: 293px; height: 459px;">
                                <div class="hotel-item style-7">
                                    <div class="radius-top">
                                        <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-echo="https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_265/v1513378821/DSC01484_p6lvat.jpg"
                                            alt="">

                                    </div>
                                    <div class="title">
                                        <h5>desde
                                            <strong class="color-red-3">20.000 COP</strong>
                                        </h5>
                                        <!--  <h6 class="color-grey-3">Dormitorio</h6>-->
                                        <h4>
                                            <b>Dormitorio</b>
                                        </h4>
                                        <p>Dormitorio con baño privado, ideal cuando viajas con tu grupo de amigos
                                        </p>
                                        <div class="clearfix">
                                            <a href="#" class="c-button b-40 bg-red-3 hv-red-3-o fl">book now</a>
                                            <a href="#" class="c-button b-40 color-grey-3 hv-o fr">
                                                <img src="/static/img/flag_icon_grey.png" alt="">ver mas</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide swiper-slide-visible" style="width: 293px; height: 459px;">
                                <div class="hotel-item style-7">
                                    <div class="radius-top">
                                        <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-echo="https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_265/v1513380734/DSC01463_meygti.jpg"
                                            alt="">

                                    </div>
                                    <div class="title">
                                        <h5>desde
                                            <strong class="color-red-3">20.000 COP</strong>
                                        </h5>
                                        <!--  <h6 class="color-grey-3">Dormitorio</h6>-->
                                        <h4>
                                            <b>Dormitorio</b>
                                        </h4>
                                        <p>Dormitorio con baño privado, ideal cuando viajas con tu grupo de amigos
                                        </p>
                                        <div class="clearfix">
                                            <a href="#" class="c-button b-40 bg-red-3 hv-red-3-o fl">book now</a>
                                            <a href="#" class="c-button b-40 color-grey-3 hv-o fr">
                                                <img src="/static/img/flag_icon_grey.png" alt="">ver mas</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pagination poin-style-2 pagination-swiper-unique-id-0">
                                <span class="swiper-pagination-switch swiper-visible-switch swiper-active-switch" style="display: inline-block;"></span>
                                <span class="swiper-pagination-switch swiper-visible-switch" style="display: none;"></span>
                                <span class="swiper-pagination-switch swiper-visible-switch" style="display: none;"></span>
                                <span class="swiper-pagination-switch swiper-visible-switch" style="display: none;"></span>
                            </div>
                        </div>
                        <div class="swiper-arrow-left offers-arrow color-4">
                            <span class="fa fa-angle-left"></span>
                        </div>
                        <div class="swiper-arrow-right offers-arrow color-4">
                            <span class="fa fa-angle-right"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-wraper">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-sm-8 col-sm-offset-2">
                        <div class="second-title">
                            <h4 class="subtitle color-dark-2-light">Hostal Pelikan Taganga</h4>
                            <h2>Nuestro servicios</h2>
                            <p class="color-grey">Curabitur nunc erat, consequat in erat ut, congue bibendum nulla. Suspendisse id tor.</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="icon-block">
                            <img class="icon-img" src="/static/img/theme-1/c_icon_1.png" alt="">
                            <h5 class="icon-title color-dark-2">Daily cleaning service</h5>
                            <div class="icon-text color-dark-2-light">Sed sit amet leo orci. Fusce tincidunt accumsan pretium. Donec fermentum, ex non placerat.</div>
                            <a href="#" class="c-button small bg-sea-t hv-sea-t delay-2">
                                <span>ver mas</span>
                            </a>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="icon-block">
                            <img class="icon-img" src="/static/img/theme-1/c_icon_2.png" alt="">
                            <h5 class="icon-title color-dark-2">24/7 security and reception</h5>
                            <div class="icon-text color-dark-2-light">Sed sit amet leo orci. Fusce tincidunt accumsan pretium. Donec fermentum, ex non placerat.</div>
                            <a href="#" class="c-button small bg-sea-t hv-sea-t delay-2">
                                <span>ver mas</span>
                            </a>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="icon-block">
                            <img class="icon-img" src="/static/img/theme-1/c_icon_3.png" alt="">
                            <h5 class="icon-title color-dark-2">Gratis wifi (8Mb/s)</h5>
                            <div class="icon-text color-dark-2-light">Disfruta de nuestro servicio WiFi las 24 horas, en todo el hostal para que no pierdas comunicación en ningún instante.

Enjoy our WiFi service 24 hours around the hostel so you do not miss any instant communication.</div>
                            <a href="#" class="c-button small bg-sea-t hv-sea-t delay-2">
                                <span>ver mas</span>
                            </a>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="icon-block">
                            <img class="icon-img" src="/static/img/theme-1/c_icon_4.png" alt="">
                            <h5 class="icon-title color-dark-2">in bussines</h5>
                            <div class="icon-text color-dark-2-light">Sed sit amet leo orci. Fusce tincidunt accumsan pretium. Donec fermentum, ex non placerat.</div>
                            <a href="#" class="c-button small bg-sea-t hv-sea-t delay-2">
                                <span>ver mas</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-wraper">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-sm-8 col-sm-offset-2">
                        <div class="second-title">
                            <!--  <h4 class="subtitle color-dark-2-light">our gallery</h4> -->
                            <h2>Lugares cerca de ti</h2>
                            <p class="color-grey">Hostal Pelikan Taganga</p>
                        </div>
                    </div>
                </div>
                <div class="isotope-container row row10">
                    <div class="grid-sizer col-mob-12 col-xs-6 col-sm-3"></div>
                    <div class="item gal-item col10 col-mob-12 col-xs-6 col-sm-6">
                        <a class="black-hover" href="#">
                            <img class="/static/img-full img-responsive" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                                data-echo="https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_580/v1513656026/stock-photo-140004939_vx6pay.jpg"
                                alt="">
                            <div class="tour-layer delay-1"></div>
                            <div class="vertical-align">
                                <div class="date color-white">July
                                    <strong>19th</strong> to July
                                    <strong>26th</strong>
                                </div>
                                <h4 class="color-white">
                                    <b>tours in taganga</b>
                                </h4>
                            </div>
                        </a>
                    </div>
                    <div class="item gal-item col10 col-mob-12 col-xs-6 col-sm-3">
                        <a class="black-hover" href="#">
                            <img class="/static/img-full img-responsive" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                                data-echo="https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_285/v1513656022/stock-photo-121747485_u2omz9.jpg"
                                alt="">
                            <div class="tour-layer delay-1"></div>
                            <div class="vertical-align">
                                <div class="date color-white">July
                                    <strong>19th</strong> to July
                                    <strong>26th</strong>
                                </div>
                                <h4 class="color-white">
                                    <b>tours in taganga</b>
                                </h4>
                            </div>
                        </a>
                    </div>
                    <div class="item gal-item col10 col-mob-12 col-xs-6 col-sm-3">
                        <a class="black-hover" href="#">
                            <img class="/static/img-full img-responsive" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                                data-echo="https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_285/v1513655993/stock-photo-50111228_lti995.jpg"
                                alt="">
                            <div class="tour-layer delay-1"></div>
                            <div class="vertical-align">
                                <div class="date color-white">July
                                    <strong>19th</strong> to July
                                    <strong>26th</strong>
                                </div>
                                <h4 class="color-white">
                                    <b>tours in taganga</b>
                                </h4>
                            </div>
                        </a>
                    </div>
                    <!--
                <div class="item gal-item col10 col-mob-12 col-xs-6 col-sm-3">
                    <a class="black-hover" href="#">
                        <img class="/static/img-full img-responsive" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-echo="https://res.cloudinary.com/dxmudfvor/image/upload/c_fit,w_285,h_180/v1513656016/stock-photo-156613485_s8u6vc.jpg" alt="">
                        <div class="tour-layer delay-1"></div>
                        <div class="vertical-align">
                            <div class="date color-white">July
                                <strong>19th</strong> to July
                                <strong>26th</strong>
                            </div>
                            <h4 class="color-white">
                                <b>tours in taganga</b>
                            </h4>
                        </div>
                    </a>
                </div>
            -->
                    <div class="item gal-item col10 col-mob-12 col-xs-6 col-sm-6">
                        <a class="black-hover" href="#">
                            <img class="/static/img-full img-responsive" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                                data-echo="https://res.cloudinary.com/dxmudfvor/image/upload/c_fill,w_580,h_185/v1513657980/DSC01679_hkdikz.jpg"
                                alt="">
                            <div class="tour-layer delay-1"></div>
                            <div class="vertical-align">
                                <div class="date color-white">July
                                    <strong>19th</strong> to July
                                    <strong>26th</strong>
                                </div>
                                <h4 class="color-white">
                                    <b>tours in taganga</b>
                                </h4>
                            </div>
                        </a>
                    </div>
                    <!--
                <div class="item gal-item col10 col-mob-12 col-xs-6 col-sm-6">
                    <a class="black-hover" href="#">
                        <img class="/static/img-full img-responsive" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-echo="https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_285/v1513656825/stock-photo-152635679_aocklj.jpg" alt="">
                        <div class="tour-layer delay-1"></div>
                        <div class="vertical-align">
                            <div class="date color-white">July
                                <strong>19th</strong> to July
                                <strong>26th</strong>
                            </div>
                            <h4 class="color-white">
                                <b>tours in taganga</b>
                            </h4>
                        </div>
                    </a>
                </div>
            -->
                    <!--
                <div class="item gal-item col10 col-mob-12 col-xs-6 col-sm-6">
                    <a class="black-hover" href="#">
                        <img class="/static/img-full img-responsive" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-echo="https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_278/v1513380991/DSC01354_oc05ib.jpg" alt="">
                        <div class="tour-layer delay-1"></div>
                        <div class="vertical-align">
                            <div class="date color-white">July
                                <strong>19th</strong> to July
                                <strong>26th</strong>
                            </div>
                            <h4 class="color-white">
                                <b>tours in taganga</b>
                            </h4>
                        </div>
                    </a>
                </div>
            -->
                    <!--
                <div class="item gal-item col10 col-mob-12 col-xs-6 col-sm-3">
                    <a class="black-hover" href="#">
                        <img class="/static/img-full img-responsive" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-echo="/static/img/home_7/gal_8.jpg" alt="">
                        <div class="tour-layer delay-1"></div>
                        <div class="vertical-align">
                            <div class="date color-white">July
                                <strong>19th</strong> to July
                                <strong>26th</strong>
                            </div>
                            <h4 class="color-white">
                                <b>tours in taganga</b>
                            </h4>
                        </div>
                    </a>
                </div>
            -->
                    <!--
                <div class="item gal-item col10 col-mob-12 col-xs-6 col-sm-3">
                    <a class="black-hover" href="#">
                        <img class="/static/img-full img-responsive" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-echo="/static/img/home_7/gal_9.jpg" alt="">
                        <div class="tour-layer delay-1"></div>
                        <div class="vertical-align">
                            <div class="date color-white">July
                                <strong>19th</strong> to July
                                <strong>26th</strong>
                            </div>
                            <h4 class="color-white">
                                <b>tours in taganga</b>
                            </h4>
                        </div>
                    </a>
                </div>
            -->
                </div>
            </div>
        </div>
        <!-- special offers 
    <div class="main-wraper">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-sm-8 col-sm-offset-2">
                    <div class="second-title">
                        <h4 class="subtitle color-dark-2-light">popular destination</h4>
                        <h2>Special offers for You</h2>
                        <p class="color-grey">Curabitur nunc erat, consequat in erat ut, congue bibendum nulla. Suspendisse id tor.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-4">
                    <div class="item-block style-3 hover-sea underline-block">
                        <img class="center-image" src="/static/img/home_7/special.jpg" alt="">
                        <div class="tour-layer delay-1"></div>
                        <div class="vertical-align">
                            <h3 class="ib-subtitle hover-it">sale
                                <span class="color-sea">-20%</span>
                            </h3>
                            <h3 class="hover-it underline">bora bora for HONEYMOON</h3>
                            <p>Cursus libero purus ac cursus ut sed.Nunc cursus libero purus ac sed vitae pulvinar.</p>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="hotel-small style-2 clearfix">
                        <a class="hotel-img black-hover" href="#">
                            <img class="/static/img-responsive radius-0" src="/static/img/home_7/small_hotel_1.jpg" alt="">
                            <div class="tour-layer delay-1"></div>
                        </a>
                        <div class="hotel-desc">
                            <h5>
                                <span class="color-dark-2-light">
                                    <strong>
                                        <s>$470</s>
                                    </strong>
                                </span>
                                <span class="color-red">
                                    <strong>$300</strong>
                                </span>
                            </h5>
                            <h4>mauritius from 5 days</h4>
                            <div class="hotel-loc">Nunc cursus libero purus ac congue.</div>
                        </div>
                    </div>
                    <div class="hotel-small style-2 clearfix">
                        <a class="hotel-img black-hover" href="#">
                            <img class="/static/img-responsive radius-0" src="/static/img/home_7/small_hotel_2.jpg" alt="">
                            <div class="tour-layer delay-1"></div>
                        </a>
                        <div class="hotel-desc">
                            <h5>
                                <span class="color-dark-2-light">
                                    <strong>
                                        <s>$470</s>
                                    </strong>
                                </span>
                                <span class="color-red">
                                    <strong>$300</strong>
                                </span>
                            </h5>
                            <h4>mauritius from 5 days</h4>
                            <div class="hotel-loc">Nunc cursus libero purus ac congue.</div>
                        </div>
                    </div>
                    <div class="hotel-small style-2 clearfix">
                        <a class="hotel-img black-hover" href="#">
                            <img class="/static/img-responsive radius-0" src="/static/img/home_7/small_hotel_3.jpg" alt="">
                            <div class="tour-layer delay-1"></div>
                        </a>
                        <div class="hotel-desc">
                            <h5>
                                <span class="color-dark-2-light">
                                    <strong>
                                        <s>$470</s>
                                    </strong>
                                </span>
                                <span class="color-red">
                                    <strong>$300</strong>
                                </span>
                            </h5>
                            <h4>mauritius from 5 days</h4>
                            <div class="hotel-loc">Nunc cursus libero purus ac congue.</div>
                        </div>
                    </div>
                    <div class="hotel-small style-2 clearfix">
                        <a class="hotel-img black-hover" href="#">
                            <img class="/static/img-responsive radius-0" src="/static/img/home_7/small_hotel_4.jpg" alt="">
                            <div class="tour-layer delay-1"></div>
                        </a>
                        <div class="hotel-desc">
                            <h5>
                                <span class="color-dark-2-light">
                                    <strong>
                                        <s>$470</s>
                                    </strong>
                                </span>
                                <span class="color-red">
                                    <strong>$300</strong>
                                </span>
                            </h5>
                            <h4>mauritius from 5 days</h4>
                            <div class="hotel-loc">Nunc cursus libero purus ac congue.</div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="hotel-small style-2 clearfix">
                        <a class="hotel-img black-hover" href="#">
                            <img class="/static/img-responsive radius-0" src="/static/img/home_7/small_hotel_5.jpg" alt="">
                            <div class="tour-layer delay-1"></div>
                        </a>
                        <div class="hotel-desc">
                            <h5>
                                <span class="color-dark-2-light">
                                    <strong>
                                        <s>$470</s>
                                    </strong>
                                </span>
                                <span class="color-red">
                                    <strong>$300</strong>
                                </span>
                            </h5>
                            <h4>mauritius from 5 days</h4>
                            <div class="hotel-loc">Nunc cursus libero purus ac congue.</div>
                        </div>
                    </div>
                    <div class="hotel-small style-2 clearfix">
                        <a class="hotel-img black-hover" href="#">
                            <img class="/static/img-responsive radius-0" src="/static/img/home_7/small_hotel_6.jpg" alt="">
                            <div class="tour-layer delay-1"></div>
                        </a>
                        <div class="hotel-desc">
                            <h5>
                                <span class="color-dark-2-light">
                                    <strong>
                                        <s>$470</s>
                                    </strong>
                                </span>
                                <span class="color-red">
                                    <strong>$300</strong>
                                </span>
                            </h5>
                            <h4>mauritius from 5 days</h4>
                            <div class="hotel-loc">Nunc cursus libero purus ac congue.</div>
                        </div>
                    </div>
                    <div class="hotel-small style-2 clearfix">
                        <a class="hotel-img black-hover" href="#">
                            <img class="/static/img-responsive radius-0" src="/static/img/home_7/small_hotel_7.jpg" alt="">
                            <div class="tour-layer delay-1"></div>
                        </a>
                        <div class="hotel-desc">
                            <h5>
                                <span class="color-dark-2-light">
                                    <strong>
                                        <s>$470</s>
                                    </strong>
                                </span>
                                <span class="color-red">
                                    <strong>$300</strong>
                                </span>
                            </h5>
                            <h4>mauritius from 5 days</h4>
                            <div class="hotel-loc">Nunc cursus libero purus ac congue.</div>
                        </div>
                    </div>
                    <div class="hotel-small style-2 clearfix">
                        <a class="hotel-img black-hover" href="#">
                            <img class="/static/img-responsive radius-0" src="/static/img/home_7/small_hotel_8.jpg" alt="">
                            <div class="tour-layer delay-1"></div>
                        </a>
                        <div class="hotel-desc">
                            <h5>
                                <span class="color-dark-2-light">
                                    <strong>
                                        <s>$470</s>
                                    </strong>
                                </span>
                                <span class="color-red">
                                    <strong>$300</strong>
                                </span>
                            </h5>
                            <h4>mauritius from 5 days</h4>
                            <div class="hotel-loc">Nunc cursus libero purus ac congue.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
-->
        <div class="main-wraper">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-sm-8 col-sm-offset-2">
                        <div class="second-title">
                            <h4 class="subtitle color-dark-2-light">testimonials</h4>
                            <h2>what our clients say</h2>
                            <p class="color-grey">Curabitur nunc erat, consequat in erat ut, congue bibendum nulla. Suspendisse id tor.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="arrows bg-bluejeans">
                <div class="swiper-container main-slider-7" data-autoplay="0" data-loop="1" data-speed="900" data-center="0" data-slides-per-view="1">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide active" data-val="0">
                            <div class="sl-bg">
                                <img class="center-image" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-echo="https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_378/v1513669975/22045879_1476305649084474_7587987462714636982_n_zo2fel.jpg"
                                    alt="">
                            </div>
                            <div class="container">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 col-md-5 col-md-offset-1">
                                        <div class="sl-testimonals">
                                            <div class="tour-info">
                                                <img src="/static/img/calendar_icon.png" alt="">
                                                <span class="font-style-2 color-white">July
                                                    <b> 19th</b> to July
                                                    <b> 26th</b>
                                                </span>
                                            </div>
                                            <h3 class="color-white underline">Juliana y Jose</h3>
                                            <p class="f-14 color-white">“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                                                nostrud exercitation.”</p>

                                            <img class="sl-img" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="">
                                            <img class="sl-img" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="">
                                            <img class="sl-img" style="opacity: 0;" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-echo="/static/img/home_7/sl_3.jpg"
                                                alt="">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="pagination pagination-hidden poin-style-1"></div>
                        <div class="arrow-wrapp arr-s-4">
                            <div class="cont-1170">
                                <div class="swiper-arrow-left sw-arrow">
                                    <span class="fa fa-angle-left"></span>
                                </div>
                                <div class="swiper-arrow-right sw-arrow">
                                    <span class="fa fa-angle-right"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-wraper padd-90">
                <div class="container">
                    <div class="row">
                        <div class="col-xs-12 col-sm-8 col-sm-offset-2">
                            <div class="second-title">
                                <h4 class="subtitle color-dark-2-light">Mejor compartir</h4>
                                <h2>Apoyos y amigos</h2>
                                <p class="color-grey">Curabitur nunc erat, consequat in erat ut, congue bibendum nulla. Suspendisse id tor.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-container" data-autoplay="0" data-loop="1" data-speed="1000" data-center="0" data-slides-per-view="responsive"
                    data-mob-slides="1" data-xs-slides="2" data-sm-slides="3" data-md-slides="4" data-lg-slides="5" data-add-slides="6">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="partner-entry">
                                <a href="#">
                                    <img class="/static/img-responsive" src="https://via.placeholder.com/110x91?text=Logo" alt="">
                                </a>
                            </div>
                        </div>
                        <div class="swiper-slide text-center">
                            <div class="partner-entry">
                                <a href="#">
                                    <img class="/static/img-responsive" src="https://via.placeholder.com/110x91?text=Logo" alt="">
                                </a>
                            </div>
                        </div>
                        <div class="swiper-slide text-center">
                            <div class="partner-entry">
                                <a href="#">
                                    <img class="/static/img-responsive" src="https://via.placeholder.com/110x91?text=Logo" alt="">
                                </a>
                            </div>
                        </div>
                        <div class="swiper-slide text-center">
                            <div class="partner-entry">
                                <a href="#">
                                    <img class="/static/img-responsive" src="https://via.placeholder.com/110x91?text=Logo" alt="">
                                </a>
                            </div>
                        </div>
                        <div class="swiper-slide text-center">
                            <div class="partner-entry">
                                <a href="#">
                                    <img class="/static/img-responsive" src="https://via.placeholder.com/110x91?text=Logo" alt="">
                                </a>
                            </div>
                        </div>
                        <div class="swiper-slide text-center">
                            <div class="partner-entry">
                                <a href="#">
                                    <img class="/static/img-responsive" src="https://via.placeholder.com/110x91?text=Logo" alt="">
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="pagination pagination-hidden"></div>
                </div>
            </div>
            <div class="container-fluid">
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  methods: {
  },
  computed: {
  },
  mounted () {
      console.log('ready')
      this.$nextTick(function () {
    // code that assumes this.$el is in-document
     window.echo.init({
                    offset: 4000,
                    throttle: 250,
                    unload: false,
                    callback: function (element, op) {
                        // console.log(element, 'has been', op + 'ed')
                        // console.log(element.outerHTML)
                        if (element.outerHTML.includes('1463')) {
                            window.slideLoaded = true
                        }
                    }
                });

    })
  },
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      msg: 'Hello World!'
    }
  }
}
</script>



// WEBPACK FOOTER //
// Homepage.vue?9c3ee91a